<div class="flex flex-row aifs rel">
  <div class="flex" *ngIf="!tipTemplate">
    <div>
      <ng-content></ng-content>
    </div>
  </div>

  <ng-container *ngIf="tipTemplate">
    <ng-container *ngTemplateOutlet="tipTemplate"></ng-container>
  </ng-container>

  <rx-icon name="close" [id]="'close-' + id" (click)="onClose()" *ngIf="showClose"></rx-icon>
</div>
